import { lazy } from "react";
import ClinicData from "./admin/pages/clinicData/ClinicData";
import BookTreatment from "./admin/pages/bookdentist/booktreatent/BookTreatment";
// MUI Icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import PaymentIcon from "@mui/icons-material/Payment";
import SettingsIcon from "@mui/icons-material/Settings";
import BusinessIcon from "@mui/icons-material/Business";

const AdminDashBoard = lazy(
  () => import("./admin/pages/adminDashboard/AdminDashBoard")
);
const Clinic = lazy(() => import("./admin/pages/clinic/Clinic"));
const AddClinic = lazy(
  () => import("./admin/pages/clinic/addclinic/AddClinic")
);
const AllClinic = lazy(
  () => import("./admin/pages/clinic/allclinic/AllClinic")
);
const EditClinic = lazy(
  () => import("./admin/pages/clinic/editClinic/EditClinic")
);
const ViewClinic = lazy(
  () => import("./admin/pages/clinic/viewClinic/ViewClinic")
);
const Payment = lazy(() => import("./admin/pages/payment/Payment"));
const AllPayment = lazy(
  () => import("./admin/pages/payment/allPayment/AllPayment")
);
const PendingPayment = lazy(
  () => import("./admin/pages/payment/pendingPayment/PendingPayment")
);
const CompletePayment = lazy(
  () => import("./admin/pages/payment/completePayment/CompletePayment")
);
const AdvancedPayment = lazy(
  () => import("./admin/pages/payment/advancedPayment/AdvancedPayment")
);

export const ADMINROUTES = [
  {
    title: "Dashboard",
    icon: DashboardIcon,
    Element: AdminDashBoard,
    path: "/admin/dashboard",
  },
  {
    title: "Clinic Data",
    icon: BusinessIcon,
    Element: ClinicData,
    path: "/admin/clinicData",
  },
  {
    title: "Clincs",
    icon: BusinessIcon,
    Element: Clinic,
    path: "/admin/clincs",
    topnav: [
      {
        title: "All Clinics",
        path: "/admin/clincs/all-clinic",
        Element: AllClinic,
      },
      {
        title: "Add Clinics",
        path: "/admin/clincs/add-clinic",
        Element: AddClinic,
      },
      {
        title: "Edit Clinics",
        path: "/admin/clincs/edit-clinic/:ID",
        Element: EditClinic,
        isParam: true,
      },
      {
        title: "Edit Clinics",
        path: "/admin/clincs/view-clinic/:ID",
        Element: ViewClinic,
        isParam: true,
      },
    ],
  },
  {
    title: "Payment",
    icon: PaymentIcon,
    path: "/admin/payment",
    Element: Payment,
    topnav: [
      {
        title: "all payment",
        path: "/admin/payment/all-payment",
        Element: AllPayment,
      },
      {
        title: "complete payment",
        path: "/admin/payment/complete-payment",
        Element: CompletePayment,
      },
      {
        title: "pending payment",
        path: "/admin/payment/pending-payment",
        Element: PendingPayment,
      },
      {
        title: "advanced payment",
        path: "/admin/payment/advanced-payment",
        Element: AdvancedPayment,
      },
    ],
  },
  {
    title: "Setting",
    icon: SettingsIcon,
    Element: Payment,
    path: "/admin/setting",
    topnav: [
      {
        title: "Register Number",
        path: "/admin/setting/regnumber",
        Element: AllClinic,
      },
    ],
  },
  {
    title: "booktreatment",
    icon: MedicalServicesIcon,
    Element: BookTreatment,
    path: "/admin/booktreatment",
  },
];
